// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px)";
var _4 = "service-1s6x4";
var _5 = "service__wrapper-1zb47";
var _6 = "service_hasProducts-2yDLD";
var _7 = "main-3Wyzt";
var _8 = "header-Nfb4p";
var _9 = "desc-10_m5";
var _a = "action__icon-3JRni";
var _b = "direction-3tmM3";
var _c = "values-2iFJj";
var _d = "price-QO3-A";
var _e = "icon-frh9R";
var _f = "segment-3Eda-";
var _10 = "price__from-j0_D_";
var _11 = "action-3gLe-";
var _12 = "action__text-2iG6D";
var _13 = "service_canAdd-21061";
var _14 = "service_disabledAdd-1EjcE";
var _15 = "service_readonly-19wgu";
var _16 = "totalPrice-1k5sL";
var _17 = "selectedSeats__prices-2Jwr9";
var _18 = "selectedSeats__prices__price-249uH";
var _19 = "dialog__content-34zKx";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet", _4 as "service", _5 as "service__wrapper", _6 as "service_hasProducts", _7 as "main", _8 as "header", _9 as "desc", _a as "action__icon", _b as "direction", _c as "values", _d as "price", _e as "icon", _f as "segment", _10 as "price__from", _11 as "action", _12 as "action__text", _13 as "service_canAdd", _14 as "service_disabledAdd", _15 as "service_readonly", _16 as "totalPrice", _17 as "selectedSeats__prices", _18 as "selectedSeats__prices__price", _19 as "dialog__content" }
export default { "__esModule": _1, "mobile": _2, "tablet": _3, "service": _4, "service__wrapper": _5, "service_hasProducts": _6, "main": _7, "header": _8, "desc": _9, "action__icon": _a, "direction": _b, "values": _c, "price": _d, "icon": _e, "segment": _f, "price__from": _10, "action": _11, "action__text": _12, "service_canAdd": _13, "service_disabledAdd": _14, "service_readonly": _15, "totalPrice": _16, "selectedSeats__prices": _17, "selectedSeats__prices__price": _18, "dialog__content": _19 }
